import React, { useState, useEffect } from "react";
import {
  Switch,
  Input,
  Radio,
  Button,
  notification,
  Modal as ModalAntd,
  Table,
  BackTop
} from "antd";
import {
  EditOutlined,
  StopOutlined,
  DeleteOutlined,
  CheckOutlined,
  PlusOutlined
} from "@ant-design/icons";

import { Popover } from "antd";
import Modal from "../../../Modal";
import EditTeacherCollabForm from "../EditTeacherCollabForm";
import AddTeacherCollabForm from "../AddTeacherCollabForm";
import { activateTeacherCollabApi, deleteTeacherCollabApi } from "../../../../api/teacherCollab";
import { getCoursesByTeacherCollabApi } from "../../../../api/course";
import { getAccessToken } from "../../../../api/auth";
import { checkAction, isAdmin } from "../../../../utils/checkUserPermission";
import { getRoleByIdApi } from "../../../../api/role";
import { getPermissionsActiveApi } from "../../../../api/permission";
import jwtDecode from "jwt-decode";

import "./ListTeacherCollabs.scss";

const { confirm } = ModalAntd;
const { Search } = Input;

export default function ListTeacherCollabs(props) {
  const {
    teacherCollabsActive,
    teacherCollabsInactive,
    setReloadTeacherCollabs,
  } = props;
  const [permissionsActive, setPermissionsActive] = useState([]);
  const [roleById, setRoleById] = useState([]);
  const [viewTeacherCollabsActives, setViewTeacherCollabsActives] = useState(true);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const [filterText, setFilterText] = useState("");
  const [teacherCollabsActiveFilter, setTeacherCollabsActiveFilter] = useState(
    []
  );
  const [ teacherCollabsInactiveFilter, setTeacherCollabsInactiveFilter ] = useState([]);

  const accessToken = getAccessToken();
  const userToken = jwtDecode(accessToken); //para obtener los datos del user logueado

  useEffect(() => {
    getPermissionsActiveApi(accessToken, true).then(response => {
      setPermissionsActive(response.permissions);
    });
  }, []);

  useEffect(() => {
    getRoleByIdApi(accessToken, userToken.role).then(response => {
      setRoleById(response.role);
    });
  }, []);

  useEffect(() => {
    const listActive = [];
    if (teacherCollabsActive) {
      teacherCollabsActive.forEach((element) => {
          if (
            element.description.toString()
            .toUpperCase()
            .includes(filterText.toUpperCase()) ||
            (element.teacherCollab_code && element.teacherCollab_code.toString()
            .toUpperCase()
            .includes(filterText.toUpperCase()))||
            filterText === ""
          ) {
            listActive.push(element);
          }
      });
    }
    setTeacherCollabsActiveFilter(listActive);
  }, [filterText, teacherCollabsActive]);

  useEffect(() => {
    const listInactive = [];
    if (teacherCollabsInactive) {
      teacherCollabsInactive.forEach((element) => {
          if (
            element.description
              .toUpperCase()
              .indexOf(filterText.toUpperCase()) !== -1 ||
            filterText === ""
          ) {
            listInactive.push(element);
          }
      });
    }
    setTeacherCollabsInactiveFilter(listInactive);
  }, [filterText, teacherCollabsInactive]);

  const addTeacherCollabModal = () => {
    setIsVisibleModal(true);
    setModalTitle("Crear Colaborador Docente");
    setModalContent(
      <AddTeacherCollabForm
        setIsVisibleModal={setIsVisibleModal}
        setReloadTeacherCollabs={setReloadTeacherCollabs}
      />
    );
  };

  return (
    <div className="list-teachercollabs">
      <div className="list-teachercollabs__header">
        {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
        checkAction(permissionsActive, userToken.role, "teachercollabs", "enable") || isAdmin(roleById) ? (
          <>
            <div className="list-teachercollabs__header-switch">
              <Switch
                defaultChecked
                onChange={() =>
                  setViewTeacherCollabsActives(!viewTeacherCollabsActives)
                }
              />
              <span>
                {viewTeacherCollabsActives
                  ? "Activos"
                  : "Inactivos"}
              </span>
            </div>
          </>
          ) : (
            <>
            </>
        )}

        {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
        checkAction(permissionsActive, userToken.role, "teachercollabs", "add") || isAdmin(roleById) ? (
          <>
            <Button type="primary" icon={<PlusOutlined/>} onClick={addTeacherCollabModal}>
              Nuevo
            </Button>
          </>
        ) : (
          <>
          </>
        )}
      </div>

      {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
      checkAction(permissionsActive, userToken.role, "teachercollabs", "view") || isAdmin(roleById) ? (
        <>
          <div className="list-teachercollabs__search">
            <Search
              className="Buscar"
              allowClear
              placeholder=""
              onChange={(e) => setFilterText(e.target.value)}
              enterButton
            />
            {/*
            <h2>

            </h2>
            <h3>
              <strong>Info:</strong> docentes.
            </h3>
            */}
          </div>
        </>
      ) : (
        <>
        </>
      )}

      {viewTeacherCollabsActives ? (
        <>
          {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
          checkAction(permissionsActive, userToken.role, "teachercollabs", "view") || isAdmin(roleById) ? (
            <>
              <TeacherCollabsActive
                teacherCollabsActive={teacherCollabsActiveFilter}
                setIsVisibleModal={setIsVisibleModal}
                setModalTitle={setModalTitle}
                setModalContent={setModalContent}
                setReloadTeacherCollabs={setReloadTeacherCollabs}
                accessToken={accessToken}
                userToken={userToken}
                permissionsActive={permissionsActive}
                roleById={roleById}
              />
            </>
          ) : (
            <>
            </>
          )}
        </>
      ) : (
        <>
          {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
          checkAction(permissionsActive, userToken.role, "teachercollabs", "view") || isAdmin(roleById) ? (
            <>
              <TeacherCollabsInactive
                teacherCollabsInactive={teacherCollabsInactiveFilter}
                setIsVisibleModal={setIsVisibleModal}
                setReloadTeacherCollabs={setReloadTeacherCollabs}
                setModalTitle={setModalTitle}
                setModalContent={setModalContent}
                accessToken={accessToken}
                userToken={userToken}
                permissionsActive={permissionsActive}
                roleById={roleById}
              />
            </>
          ) : (
            <>
            </>
          )}
        </>
      )}

      <Modal
        title={modalTitle}
        isVisible={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={800}
      >
        {modalContent}
      </Modal>

      <BackTop/>
    </div>
  );
}

function TeacherCollabsActive(props) {
  const {
    teacherCollabsActive,
    setIsVisibleModal,
    setModalTitle,
    setModalContent,
    setReloadTeacherCollabs,
    accessToken,
    userToken,
    permissionsActive,
    roleById
  } = props;

  const editTeacherCollab = (teacherCollab) => {
    setIsVisibleModal(true);
    setModalTitle(
      `Editar ${teacherCollab.description ? teacherCollab.description : "sin descripción"}`
    );
    setModalContent(
      <EditTeacherCollabForm
        teacherCollab={teacherCollab}
        setIsVisibleModal={setIsVisibleModal}
        setReloadTeacherCollabs={setReloadTeacherCollabs}
      />
    );
  };

  const desactivateTeacherCollab = (teacherCollab) => {
    const accessToken = getAccessToken();

    activateTeacherCollabApi(accessToken, teacherCollab._id, false)
      .then((response) => {
        notification["success"]({
          message: response.message,
        });
        setReloadTeacherCollabs(true);
      })
      .catch((err) => {
        notification["error"]({
          message: err,
        });
      });
  };

  const showDeleteConfirm = async (teacherCollab) => {
    const accessToken = getAccessToken();
    let response = await getCoursesByTeacherCollabApi(accessToken, teacherCollab._id);
    if(response.courses.length > 0){
      confirm({
        title: "Eliminando -> Colaborador Docente",
        content:`No se puede eliminar '${teacherCollab.description? teacherCollab.description : "sin descripción"}' porque existen cursos asociados a él,¿Deseas desactivarlo?`,
        okText: "Desactivar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          desactivateTeacherCollab(teacherCollab);
        },
      });
    } else {
      confirm({
        title: "Eliminando -> Colaborador Docente",
        content: `¿Estás seguro que quieres eliminar a ${teacherCollab.description}?`,
        okText: "Eliminar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          deleteTeacherCollabApi(accessToken, teacherCollab._id)
            .then((response) => {
              if (response.code === 200) {
                notification["success"]({
                  message: response.message,
                });
                setReloadTeacherCollabs(true);
              } else if (response.code === 404 || response.code === 500) {
                notification["error"]({
                  message: response.message,
                });
              } else if (
                response === "ERR_CONNECTION_REFUSED" ||
                response === "Failed to fetch" ||
                response === undefined
              ) {
                notification["error"]({
                  message: "Servidor caido",
                });
              } else {
                notification["error"]({
                  message: "Error del servidor",
                });
              }
            })
            .catch((err) => {
              notification["error"]({
                message: err,
              });
            });
        },
      });
    }
    
  };

  const edit_teacherCollab = (
    <div>
      {" "}
      <p>Editar Colaborador Docente</p>{" "}
    </div>
  );

  const desactivate_teacherCollab = (
    <div>
      {" "}
      <p>Pasar a Colaboradores Docentes inactivos</p>{" "}
    </div>
  );

  const delete_teacherCollab = (
    <div>
      {" "}
      <p>Eliminar Colaborador Docente</p>{" "}
    </div>
  );

  const columns = [
    {
      title: "Código",
      dataIndex: "teachercollab_code",
    },
    {
      title: "Descripción",
      dataIndex: "description",
    },
    {
      title: "Acción",
      key: "action",
      render: (text, teacherCollab) => (
        <div>
          {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
          checkAction(permissionsActive, userToken.role, "teachercollabs", "edit") || isAdmin(roleById) ? (
            <>
              <Popover content={edit_teacherCollab}>
                <Button
                  className="button-edit"
                  onClick={() => editTeacherCollab(teacherCollab)}
                >
                  <EditOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
          checkAction(permissionsActive, userToken.role, "teachercollabs", "enable") || isAdmin(roleById) ? (
            <>
              <Popover content={desactivate_teacherCollab}>
                <Button
                  className="button-teachercollab"
                  type="primary"
                  onClick={() => desactivateTeacherCollab(teacherCollab)}
                >
                  <StopOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
          checkAction(permissionsActive, userToken.role, "teachercollabs", "delete") || isAdmin(roleById) ? (
            <>
              <Popover content={delete_teacherCollab}>
                <Button
                  className="button-teachercollab"
                  type="danger"
                  onClick={() => showDeleteConfirm(teacherCollab)}
                >
                  <DeleteOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      footer={()=>{return teacherCollabsActive.length > 0? `Total de registros: ${teacherCollabsActive.length}`: false}}
      pagination={{
        pageSize: 50,
        showSizeChanger: false,
      }}
      dataSource={teacherCollabsActive}
      columns={columns}
      rowKey="_id"
    />
  );
}

function TeacherCollabsInactive(props) {
  const { teacherCollabsInactive,
          setReloadTeacherCollabs,
          accessToken,
          userToken,
          permissionsActive,
          roleById
        } = props;

  const activateTeacherCollab = (teacherCollab) => {
    const accessToken = getAccessToken();

    activateTeacherCollabApi(accessToken, teacherCollab._id, true)
      .then((response) => {
        notification["success"]({
          message: response.message,
        });
        setReloadTeacherCollabs(true);
      })
      .catch((err) => {
        notification["error"]({
          message: err,
        });
      });
  };

  const showDeleteConfirm = async (teacherCollab) => {
    const accessToken = getAccessToken();
    let response = await getCoursesByTeacherCollabApi(accessToken, teacherCollab._id);
    if(response.courses.length > 0){
      ModalAntd.info({
        title: "Eliminando -> Colaborador Docente",
        content:`No se puede eliminar '${teacherCollab.description? teacherCollab.description : "sin descripción"}' porque existen cursos asociados a él`,
        onOk() {
        },
      });
    } else {
      confirm({
        title: "Eliminando -> Colaborador Docente",
        content: `¿Estás seguro que quieres eliminar a ${teacherCollab.description}?`,
        okText: "Eliminar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          deleteTeacherCollabApi(accessToken, teacherCollab._id)
            .then((response) => {
              if (response.code === 200) {
                notification["success"]({
                  message: response.message,
                });
                setReloadTeacherCollabs(true);
              } else if (response.code === 404 || response.code === 500) {
                notification["error"]({
                  message: response.message,
                });
              } else if (
                response === "ERR_CONNECTION_REFUSED" ||
                response === "Failed to fetch" ||
                response === undefined
              ) {
                notification["error"]({
                  message: "Servidor caido",
                });
              } else {
                notification["error"]({
                  message: "Error del servidor",
                });
              }
            })
            .catch((err) => {
              notification["error"]({
                message: err,
              });
            });
        },
      });
    }
  };

  const activate_teacherCollab = (
    <div>
      {" "}
      <p>Pasar a Colaboradores Docentes activos</p>{" "}
    </div>
  );

  const delete_teacherCollab = (
    <div>
      {" "}
      <p>Eliminar Colaborador Docente</p>
    </div>
  );

  const columns = [
    {
      title: "Código",
      dataIndex: "teachercollab_code",
    },
    {
      title: "Descripción",
      dataIndex: "description",
    },
    {
      title: "Acción",
      key: "action",
      render: (text, teacherCollab) => (
        <div>
          {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
          checkAction(permissionsActive, userToken.role, "teachercollabs", "edit") || isAdmin(roleById) ? (
            <>
              <Popover content={activate_teacherCollab}>
                <Button
                  className="button-activate"
                  onClick={() => activateTeacherCollab(teacherCollab)}
                >
                  <CheckOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "teachercollabs", "all") ||
          checkAction(permissionsActive, userToken.role, "teachercollabs", "delete") || isAdmin(roleById) ? (
            <>
              <Popover content={delete_teacherCollab}>
                <Button
                  className="button-teachercollab"
                  type="danger"
                  onClick={() => showDeleteConfirm(teacherCollab)}
                >
                  <DeleteOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      footer={()=>{return teacherCollabsInactive.length > 0? `Total de registros: ${teacherCollabsInactive.length}`: false}}
      pagination={{
        pageSize: 50,
        showSizeChanger: false,
      }}
      dataSource={teacherCollabsInactive}
      columns={columns}
      rowKey="_id"
    />
  );
}
